<template>
  <loading-logo v-if="isFetchingWebhookInfo" />
  <main v-else>
    <section>
      <div>
        <h4 class="body-bold-base neutral-20-dark--text">
          {{ $t('message.pages.drm.drmWatermark.waterMarkInfo') }}
        </h4>
        <h5 class="body-regular-smaller neutral-40-light--text">
          {{ $t('message.pages.drm.drmWatermark.waterMarkInfoDescription') }}
        </h5>
      </div>
      <div
        class="d-flex justify-space-between mt-2"
        :class="{
          'flex-column': isMobileBreakpoint,
          'align-center': !isMobileBreakpoint,
        }"
      >
        <span class="body-regular-small neutral-20-dark--text">{{
          $t('message.pages.drm.drmWatermark.showWaterMark')
        }}</span>
        <v-tooltip
          bottom
          :disabled="['hotmart', 'eduzz'].includes(selectedSourceWebhook)"
        >
          <template v-slot:activator="{ on, attrs }">
            <div
              style="width: 50%"
              v-bind="attrs"
              v-on="on"
              :style="{ width: isMobileBreakpoint ? '100%' : '50%' }"
            >
              <v-select
                v-model="watermarkDisplay"
                :items="watermarkDisplayOptions"
                :placeholder="
                  !['hotmart', 'eduzz'].includes(selectedSourceWebhook)
                    ? $t('message.pages.drm.drmWatermark.placeHolderDisabled')
                    : ''
                "
                :disabled="
                  !['hotmart', 'eduzz'].includes(selectedSourceWebhook)
                "
                item-text="label"
                item-value="value"
                @change="handleWebhookChange1"
                hide-details
              />
            </div>
          </template>
          <span>{{
            selectedSourceWebhook.toLowerCase() == 'api'
              ? $t('message.pages.drm.drmWatermark.notAllowedApi')
              : $t('message.pages.drm.drmWatermark.notAllowedEdit')
          }}</span>
        </v-tooltip>
      </div>
      <v-row no-gutters v-if="watermarkDisplay == 'custom'">
        <v-col cols="6" class="mt-4">
          <span class="text-body-2">{{
            $t('message.pages.drm.settingsForm.firstField')
          }}</span>
        </v-col>
        <v-col :cols="!isMobileBreakpoint ? '6' : '12'">
          <Tiptap
            :name="field1.name"
            :contentValue="field1.contentValue"
            :webhookFields="webhookFields"
            @updateContent="handleWebhookChange1"
          ></Tiptap>
        </v-col>
        <v-col :cols="!isMobileBreakpoint ? '6' : '12'" class="mt-4">
          <span class="text-body-2">{{
            $t('message.pages.drm.settingsForm.secondField')
          }}</span>
        </v-col>
        <v-col :cols="!isMobileBreakpoint ? '6' : '12'">
          <Tiptap
            :name="field2.name"
            :contentValue="field2.contentValue"
            :webhookFields="webhookFields"
            @updateContent="handleWebhookChange2"
          ></Tiptap>
        </v-col>
        <v-col :cols="!isMobileBreakpoint ? '6' : '12'" class="mt-4">
          <span class="text-body-2">{{
            $t('message.pages.drm.settingsForm.thirdField')
          }}</span>
        </v-col>
        <v-col :cols="!isMobileBreakpoint ? '6' : '12'">
          <Tiptap
            :name="field3.name"
            :contentValue="field3.contentValue"
            :webhookFields="webhookFields"
            @updateContent="handleWebhookChange3"
          ></Tiptap>
        </v-col>
      </v-row>
      <v-row no-gutters> </v-row>
    </section>
    <v-divider class="my-4" />
    <section>
      <div>
        <h4 class="body-bold-base neutral-20-dark--text">
          {{ $t('message.pages.drm.drmWatermark.questionSecurity') }}
        </h4>
        <h5 class="body-regular-smaller neutral-40-light--text">
          {{ $t('message.pages.drm.drmWatermark.questionSecurityDescription')
          }}<br />
          <a
            type="secondary"
            size="xsmall"
            target="_blank"
            :href="$t('message.pages.drm.drmWatermark.howToUseHref')"
            >{{ $t('message.pages.AssistentIntern.actions.checkHowUse') }}
            <v-icon size="11px">mdi-open-in-new</v-icon></a
          >
        </h5>
      </div>
      <div
        class="d-flex justify-space-between mt-2"
        :class="{
          'flex-column': isMobileBreakpoint,
          'align-center': !isMobileBreakpoint,
        }"
      >
        <span class="body-regular-small neutral-20-dark--text">{{
          $t('message.pages.drm.drmWatermark.textQuestion')
        }}</span>
        <v-tooltip
          bottom
          :disabled="['hotmart', 'eduzz'].includes(selectedSourceWebhook)"
        >
          <template v-slot:activator="{ on, attrs }">
            <div
              style="width: 50%"
              v-bind="attrs"
              v-on="on"
              :style="{ width: isMobileBreakpoint ? '100%' : '50%' }"
            >
              <v-input
                :placeholder="
                  !['hotmart', 'eduzz'].includes(selectedSourceWebhook)
                    ? $t('message.pages.drm.drmWatermark.placeHolderDisabled')
                    : $t('message.pages.drm.drmWatermark.placeHolder')
                "
                :disabled="
                  !['hotmart', 'eduzz'].includes(selectedSourceWebhook)
                "
                :error="!watermarkText.length"
                v-model="watermarkText"
                :maxLength="120"
                :counter="showCounter ? 120 : null"
                @focus="
                  changeQuestion()
                  showCounter = true
                "
                @blur="
                  notFocus()
                  showCounter = false
                "
                @input="changeQuestion()"
              />
            </div>
          </template>
          <span>{{ $t('message.pages.drm.drmWatermark.notAllowedEdit') }}</span>
        </v-tooltip>
      </div>
    </section>
  </main>
</template>
<script>
import Tiptap from '../Tiptap.vue'
import drmApi from '@/services/drmApi'
import { mapMutations, mapState } from 'vuex'
import LoadingLogo from '../../../components/LoadingLogo.vue'
export default {
  name: 'DrmWatermark',
  components: {
    Tiptap,
    LoadingLogo,
  },
  props: {
    selectedDrmGroup: {
      type: Object,
    },
    selectedSourceWebhook: {
      type: String,
      default: 'API',
    },
    webhookValue: {
      type: Object,
    },
  },
  data() {
    return {
      showCounter: false,
      startWebhookValue: {},
      field1: {
        name: 'field1',
        contentValue: [],
        savedValue: '',
      },
      field2: {
        name: 'field2',
        contentValue: [],
        savedValue: '',
      },
      field3: {
        name: 'field3',
        contentValue: [],
        savedValue: '',
      },
      field1Saved: '',
      field2Saved: '',
      field3Saved: '',
      webhookFields: [],
      startWatermarkText: '',
      watermarkDisplayOptions: [
        {
          label: this.$t(
            'message.pages.drm.drmWatermark.optionsWatermark.default'
          ),
          value: 'default',
        },
        {
          label: this.$t(
            'message.pages.drm.drmWatermark.optionsWatermark.custom'
          ),
          value: 'custom',
        },
      ],
      watermarkDisplay: 'default',
      watermarkText: '',
      isFetchingWebhookInfo: false,
    }
  },
  computed: {
    ...mapState({
      isMobileBreakpoint: (state) => state.user.isMobileBreakpoint,
    }),
  },
  methods: {
    ...mapMutations('user', [
      'UPDATE_GLOBAL_SNACKBAR',
      'UPDATE_SHOULD_FETCH_ALL_VIDEOS',
    ]),
    notFocus() {
      this.$root.$emit('notFocus', '')
    },
    changeQuestion() {
      this.$root.$emit('changeQuestion', this.watermarkText)
    },
    handleDiscardChanges() {
      this.field1.contentValue = this.fixResponseToTiptap(
        this.field1.savedValue
      )
      this.field2.contentValue = this.fixResponseToTiptap(
        this.field2.savedValue
      )
      this.field3.contentValue = this.fixResponseToTiptap(
        this.field3.savedValue
      )
      this.watermarkText = this.startWatermarkText
    },
    handleWebhookChange1(value) {
      const tiptapValue = Array(value?.content || [])[0]?.content
      this.field1Saved = this.fixTiptapText(tiptapValue)
      let webhookObj = {
        model_string1: this.fixTiptapText(tiptapValue),
        model_string2: this.field2Saved
          ? this.fixTiptapText(this.field2Saved)
          : '',
        model_string3: this.field3Saved
          ? this.fixTiptapText(this.field3Saved)
          : '',
        token_verification: this.tokenVerification,
        source_name: this.selectedSourceWebhook,
      }
      this.changeWebhook(webhookObj)
    },
    handleWebhookChange2(value) {
      const tiptapValue = Array(value?.content || [])[0]?.content
      this.field2Saved = this.fixTiptapText(tiptapValue)
      let webhookObj = {
        model_string1: this.field1Saved
          ? this.fixTiptapText(this.field1Saved)
          : '',
        model_string2: this.fixTiptapText(tiptapValue),
        model_string3: this.field3Saved
          ? this.fixTiptapText(this.field3Saved)
          : '',
        token_verification: this.tokenVerification,
        source_name: this.selectedSourceWebhook,
      }
      this.changeWebhook(webhookObj)
    },
    handleWebhookChange3(value) {
      const tiptapValue = Array(value?.content || [])[0]?.content
      this.field3Saved = this.fixTiptapText(tiptapValue)
      let webhookObj = {
        model_string1: this.field1Saved
          ? this.fixTiptapText(this.field1Saved)
          : '',
        model_string2:
          this.field2Saved || this.fixTiptapText(this.field2.savedValue),
        model_string3: this.fixTiptapText(tiptapValue),
        token_verification: this.tokenVerification,
        source_name: this.selectedSourceWebhook,
      }
      this.changeWebhook(webhookObj)
    },
    changeWebhook(webhookValue) {
      console.log(webhookValue)
      this.$root.$emit('changeWatermark', webhookValue)
    },
    async getUserWebhooks() {
      try {
        let ret = await drmApi.listGroupWebhooks(this.selectedDrmGroup.id)
        this.startWebhookValue = ret.data
        if (ret.data.model_string1) {
          this.field1.contentValue = this.fixResponseToTiptap(
            ret.data.model_string1
          )
          this.field1.savedValue = ret.data.model_string1
        }
        if (ret.data.model_string2) {
          this.field2.contentValue = this.fixResponseToTiptap(
            ret.data.model_string2
          )
          this.field2.savedValue = ret.data.model_string2
        }
        if (ret.data.model_string3) {
          this.field3.contentValue = this.fixResponseToTiptap(
            ret.data.model_string3
          )
          this.field3.savedValue = ret.data.model_string3
        }
        if (ret.data.source_name)
          this.selectedSourceWebhook = ret.data.source_name
        if (ret.data.token_verification)
          this.tokenVerification = ret.data.token_verification
        this.changeWebhookSourceContent(ret.data.source_name)
      } catch (e) {
        this.isFetchingWebhookInfo = false
        console.log('e', e)
      }
    },

    changeWebhookSourceContent(sourceWebhook) {
      this.selectedSourceWebhook = sourceWebhook
      this.resetInputValues()
      let lowerCasedSourceWebhook = sourceWebhook.toLowerCase()
      if (
        lowerCasedSourceWebhook === 'api' ||
        lowerCasedSourceWebhook === 'ticto' ||
        lowerCasedSourceWebhook === 'memberkit'
      ) {
        return
      }
      if (sourceWebhook.length) {
        this.sourceSecondStep = true
        let selectedWebhook = this.listSourceWebhooks.find(
          (el) => el.type === sourceWebhook
        )
        this.webhookFields = selectedWebhook?.fields
      }
      if (sourceWebhook === this.startWebhookValue.source_name) {
        if (this.startWebhookValue.model_string1) {
          this.field1.contentValue = this.fixResponseToTiptap(
            this.startWebhookValue.model_string1
          )
          this.field1.savedValue = this.startWebhookValue.model_string1
        }
        if (this.startWebhookValue.model_string2) {
          this.field2.contentValue = this.fixResponseToTiptap(
            this.startWebhookValue.model_string2
          )
          console.log(this.field2.contentValue)
          this.field2.savedValue = this.startWebhookValue.model_string2
        }
        if (this.startWebhookValue.model_string3) {
          this.field3.contentValue = this.fixResponseToTiptap(
            this.startWebhookValue.model_string3
          )
          this.field3.savedValue = this.startWebhookValue.model_string3
        }
        if (this.startWebhookValue.source_name)
          this.selectedSourceWebhook = this.startWebhookValue.source_name
        if (this.startWebhookValue.token_verification)
          this.tokenVerification = this.startWebhookValue.token_verification
      }
    },
    fixTiptapText(value) {
      let res = ''
      let editorValues = value
      if (!editorValues) return res
      for (let value of editorValues) {
        if (value.type === 'mention') {
          let variableText = this.webhookFields.find((field) => {
            return field.title === value.attrs.id
          })
          let val = `###${variableText.path}###`
          res += val
        } else {
          res += ` ${value.text}`
        }
      }
      return res.trim()
    },
    fixResponseToTiptap(fieldText) {
      let res = []
      let fields = fieldText.split('###')
      for (let searchField of fields) {
        if (searchField.includes('$.')) {
          let fieldObject = this.webhookFields.find((field) => {
            return field.path === searchField
          })
          if (fieldObject) {
            let obj = {
              type: 'mention',
              attrs: {
                id: fieldObject.title,
                label: null,
              },
            }
            res.push(obj)
          }
        } else {
          if (searchField.length > 0) {
            let obj = {
              type: 'text',
              text: searchField,
            }
            res.push(obj)
          }
        }
      }
      return res
    },
    resetData() {
      Object.assign(this.$data, this.initialState())
      this.fetchData()
    },
    capitalizeFirstLetter(val) {
      return val.charAt(0).toUpperCase() + val.slice(1)
    },
    setDefaultValues() {
      this.field1.contentValue = [
        {
          type: 'text',
          text: 'Licenciado para',
        },
      ]
      this.field1.savedValue = this.fixTiptapText(this.field1.contentValue)
      let mentionIdField2 = ''
      if (this.selectedSourceWebhook === 'hotmart') {
        mentionIdField2 = 'E-mail'
      } else if (this.selectedSourceWebhook === 'eduzz') {
        mentionIdField2 = 'Nome'
      }
      this.field2.contentValue = [
        {
          type: 'mention',
          attrs: {
            id: mentionIdField2,
            label: null,
          },
        },
      ]
      this.field2.savedValue = this.fixTiptapText(this.field2.contentValue)
      let mentionIdField3 = ''
      let field3Content = []
      if (this.selectedSourceWebhook === 'hotmart') {
        mentionIdField3 = 'Nome do Produto'
      } else if (this.selectedSourceWebhook === 'eduzz') {
        field3Content = [
          {
            type: 'text',
            text: 'CPF: ',
          },
        ]
        mentionIdField3 = 'CPF'
      }
      field3Content.push({
        type: 'mention',
        attrs: {
          id: mentionIdField3,
          label: null,
        },
      })
      this.field3.contentValue = field3Content
      this.field3.savedValue = this.fixTiptapText(this.field3.contentValue)
    },
    setSavedValues() {
      this.$root.$emit(`getValue-${this.field1.name}`)
      this.$root.$emit(`getValue-${this.field2.name}`)
      this.$root.$emit(`getValue-${this.field3.name}`)
    },
    async handleEdit() {
      let groupObject = {
        name: this.selectedDrmGroup.name,
        watermark_question: this.watermarkText,
      }
      try {
        let ret = await drmApi.drmUpdateVideos(
          this.selectedDrmGroup.id,
          groupObject
        )
        this.$root.$emit('updateDrmGroup', ret.data)
      } catch (e) {
        console.log('e', e)
      }
    },
    async handleUpdateWebhook() {
      this.setSavedValues()

      this.isFetchingWebhookInfo = true
      let webhookObj = {
        model_string1: this.field1.savedValue ? this.field1.savedValue : '',
        model_string2: this.field2.savedValue ? this.field2.savedValue : '',
        model_string3: this.field3.savedValue ? this.field3.savedValue : '',
        token_verification: this.tokenVerification,
        source_name: this.selectedSourceWebhook,
        drm_group_id: this.selectedDrmGroup.id,
      }
      try {
        let ret = await drmApi.updateGroupWebhook(
          webhookObj,
          this.selectedDrmGroup.id
        )
        this.startWebhookValue = { ...this.startWebhookValue, ...ret.data }
        this.UPDATE_GLOBAL_SNACKBAR({
          open: true,
          type: 'success',
          text: this.$t('message.pages.drm.success'),
        })
        this.$root.$emit('reloadDrmWatermark')
      } catch (e) {
        console.log('e', e)
      }
    },
    resetInputValues() {
      this.tokenVerification = ''
      this.field1.savedValue = ''
      this.field1.contentValue = []
      this.field2.savedValue = ''
      this.field2.contentValue = []
      this.field3.savedValue = ''
      this.field3.contentValue = []
    },
    async getSourceWebhooks() {
      try {
        let ret = await drmApi.listSourceWebhooks(this.selectedDrmGroup.id)
        this.listSourceWebhooks = ret.data
      } catch (e) {
        this.isFetchingWebhookInfo = false
        console.log('e', e)
      }
    },
  },
  async mounted() {
    this.isFetchingWebhookInfo = true
    this.$root.$on('publish-watermark-tab', async () => {
      this.isFetchingWebhookInfo = true
      this.$root.$emit('isBtnloading', true)
      await this.handleUpdateWebhook(this.selectedDrmGroup)
      await this.handleEdit()
      await this.getUserWebhooks()
      this.$root.$emit('reloadDrmWatermark')
      this.isFetchingWebhookInfo = false
      this.$root.$emit('isBtnloading', false)
    })
    await this.getSourceWebhooks()
    await this.getUserWebhooks()
    this.isFetchingWebhookInfo = false
    this.$root.$on('updateFieldValue', (fieldName, value) => {
      this[fieldName].savedValue = this.fixTiptapText(
        value?.content[0]?.content
      )
    })
    this.$root.$on('discard-changes', () => {
      this.handleDiscardChanges()
    })
    if (
      this.startWebhookValue.model_string1 ||
      this.startWebhookValue.model_string2 ||
      this.startWebhookValue.model_string3
    ) {
      this.watermarkDisplay = 'custom'
    }
    this.watermarkText = this.selectedDrmGroup.config_player.watermark_question
    this.startWatermarkText =
      this.selectedDrmGroup.config_player.watermark_question
    if (!['hotmart', 'eduzz'].includes(this.selectedSourceWebhook)) {
      this.watermarkDisplay = ''
      this.watermarkText = ''
    }
  },
  beforeDestroy() {
    this.$root.$off('publish-watermark-tab')
    this.$root.$off('updateFieldValue')
    this.$root.$off('discard-changes')
  },
}
</script>
